<template>
	<div class="Post-List-box" v-if="Loading">
		<Loading></Loading>
	</div>
	<div class="Post-List-box" v-else>
	  
		<div class="list_box" v-if="list && list.length != 0" :class="page_name == 'home' ? 'sticky_list_box' : 'ordinary_list_box'">
			<div class="list_item" v-for="(item, index) in list" :key="index" @click="view_details(item)" :class="routeName.includes('post-details') ? 'default' : 'pointer'">
				
			  <div class="pictures_or_videos">
			  		<Swiper ref="SwiperRef" v-if="item.SlideTotal && item.SlideTotal > 0" :fileList="item" :key="'swiper-' + item.post_id"></Swiper>
			  </div>
			  
			  <div class="content_and_statistics">
				  <div class="information_big_box">
				  		<div class="information_box">
				  			<div class="avatar" :class="if_routeName_home()  ? 'avatar_default' : 'avatar_pointer'" @click.stop="check_information(item)">
				  				<img v-if="item && item.avatar && item.avatar != ''" :src="item.avatar" :alt="'TOZO Community ' + item.nickname + ' User Avatar'"/>
				  				<i v-else class="el-icon-s-custom"></i>
				  			</div>
				  			<div class="name_box">
				  				<div class="name">{{ item && item.nickname ? item.nickname : '' }}</div>
				  				<div class="release_time">{{ $fun.formatTime(item.public_time) }}</div>
				  			</div>
				  		</div>
						<div class="right_box" v-if="if_show_follow_btn(item) && get_if_routeName() ">
				  			<div class="sticky_box margin_right" v-if="routeName != 'home' && item.is_top == 1">
				  				<div class="sticky_text">
				  					{{ $t('postsArr.Pin') }}
				  				</div>
				  			</div>
				  			<div class="follow_status_box" v-if="if_show_follow_btn(item) && get_if_routeName() " :class="parent_type == 'follow' ? 'follow_box' : 'following_followers'">
				  				<div class="follow_status" @click.stop="change_state(item)" :class="item.is_follow == 1 ? 'Unfollow' : 'Follow'">
				  					{{ item.is_follow == 1 ? $t('buttonArr.Unfollow') : $t('buttonArr.Follow') }}
				  				</div>
				  			</div>
				  		</div>
				  </div>
				  <div class="content_icon_box">
						<div class="content_subjects_box">
							<div class="content_subjects" :class="routeName.includes('post-details') ? 'PostDetails' : 'content_subjects_line_clamp'">
								<h2 class="subjects_text" v-if="item.subjects && item.subjects.length > 0">
									{{ set_subjects_text(item.subjects) }}
								</h2>
								<h2 class="content_text" :class="routeName.includes('post-details') ? 'PostDetails' : 'content_text_line_clamp'" v-if="item.content" v-html="$fun.textWithLineBreaks(item.content)">
									<!-- {{item.content}} -->
								</h2>
							</div>
						</div>
						<div class="post_list_item_bottom_box">
							<div class="icon_box browse">
								<div class="icon_box_img">
									<img src="../../assets/icon/preview.png" alt="TOZO community post browsing icon">
									<!-- <i class="el-icon-view"></i> -->
									</div>
								<div class="icon_box_text">{{ item.views }}</div>
							</div>
							<div class="icon_box">
							<!-- <div class="icon_box" @click.stop="preview(item)"> -->
								<div class="icon_box_img">
									<img src="../../assets/icon/comment.png" alt="TOZO Community Post Comment Icon">
									<!-- <i class="el-icon-chat-dot-round"></i> -->
									</div>
								<div class="icon_box_text">{{ item.comment }}</div>
							</div>
							<div class="icon_box">
							<!-- <div class="icon_box" @click.stop="give(item)"> -->
								<div class="icon_box_img">
									<img v-if="item.is_thumb == 1" src="../../assets/icon/give.png" alt="TOZO Community Post Like Icon">
									<img v-else src="../../assets/icon/not_liked.png" alt="TOZO Community Post Like Icon">
									<!-- <i class="el-icon-star-on"></i> -->
									</div>
								<div class="icon_box_text">{{ item.thumb }}</div>
							</div>
							<!-- <div class="icon_box" @click.stop="location(item)">
								<div class="icon_box_img">
									<img src="../../assets/icon/place.png" alt="TOZO community posts map location icons">
									</div>
								<div class="icon_box_text">{{ item.location }}</div>
							</div> -->
								  
							<div class="more_box" :class="routeName.includes('post-details') ? 'PostDetails' : ''">
								<div class="more_relative" :class="if_show_follow_btn(item) && get_if_routeName() ? 'margin_left' : ''">
									<div class="change_more" @click.stop="change_more(item)">
										<i class="el-icon-more-outline"></i>
									</div>
									<div class="choice_box" v-if="$store.state.current_operation == item.post_id" :class="$store.state.current_operation == item.post_id ? 'show_choice_box' : 'hidde_choice_box'">
										<div class="choice_list">
											<div class="choice_item" v-for="(c_item, c_index) in if_show_follow_btn(item) ? choice_list : personal_list" v-if="get_is_top(item, c_item)" :key="c_index" @click.stop="post_operation(item, c_item)">{{ c_item.name }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
			  </div>
			  
			</div>
		</div>
		<NoData v-else calling_modules="Posts"></NoData>
		<ConfirmPrompt v-if="delpostItem != ''" :title="titlePrompt" @ConfirmFun="ConfirmFun" @CancelFun="CancelFun"></ConfirmPrompt>
		<RepliesAndComments v-if="contentBoxData" :contentBoxData="contentBoxData" @closureFun="closureFun"></RepliesAndComments>
	</div>
</template>

<script>
import Swiper from './Swiper.vue'
import { 
	post_community_postthumb, //点赞(帖子)
	post_community_userfollow,  //关注用户
	post_community_posttops, //帖子列表置顶的帖子
	post_community_toppost, //帖子置顶
	post_community_canceltoppost, //取消帖子置顶
	post_community_delpost, //删除帖子
	post_community_postnotinterest, //不感兴趣
	post_community_dislikeuser, //不喜欢该用户
	post_community_postreport, //举报 (帖子)
	post_community_postread, //浏览帖子
} from '@/api/community.js'

export default {
	name: 'RightSidebar',
	components: { Swiper },

	props: {
		Post_List: {
			type: Array,
			default: []
		},
		page_obj: {
		},
		parent_type: {
			type: String,
			default: ""
		},
		page_name: {
			type: String,
			default: ""
		},
		Loading: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			routeName: "",
			list:[],
			choice_list:[
				// {
				// 	id: 1,
				// 	type: "postnotinterest",
				// 	name: this.$t('postsArr.Not_interested'),
				// 	remarks: "不感兴趣",
				// },
				// {
				// 	id: 2,
				// 	type: "dislikeuser",
				// 	name: this.$t('postsArr.Don_t_like_the_author'),
				// 	remarks: "不喜欢作者",
				// },
				{
					id: 3,
					type: "postreport",
					name: this.$t('postsArr.Report'),
					remarks: "举报",
				},
				// {
				// 	id: 4,
				// 	type: "cancel_operation",
				// 	name: this.$t('postsArr.Cancel'),
				// 	remarks: "取消",
				// }
			],
			
			personal_list:[
				{
					id: 1,
					type: "toppost",
					name: this.$t('postsArr.Pin'),
					remarks: "置顶",
				},
				{
					id: 2,
					type: "canceltoppost",
					name: this.$t('postsArr.Unpin'),
					remarks: "取消置顶",
				},
				{
					id: 3,
					type: "delpost",
					name: this.$t('postsArr.Delete'),
					remarks: "删除",
				},
				// {
				// 	id: 4,
				// 	type: "cancel_operation",
				// 	name: "Cancel",
				// 	name: this.$t('postsArr.Cancel'),
				// }
			],
			delpostItem: "",
			titlePrompt: "",
			contentBoxData: "",
			show_more_icon: false
		}
	},
	
	// 监听
	watch: {
		"Post_List": {
			handler: function (newValue, oldValue) {
				this.organize_format()
			},
			deep: true
		},
		
		'$route': {
		   handler (newValue, oldValue) {
				this.get_routeName()
		   },
		   deep: true
		}
	},
	
	// beforeCreate() {
		
	// }
	
	created () {
	  
	},
  
	mounted() {
		this.get_routeName()
		this.organize_format()
		this.get_addEventListener()
	},
  
	methods:{
		organize_format(){
			this.Post_List
			let arr = []
			this.Post_List.forEach((item)=>{
				let num = 0
				if(item.post_type == 1 && item.pics){
					num = item.pics.length
				}else if(item.post_type == 2 && item.videos){
					num = item.videos.length
				}
				item.SlideTotal = num
				// arr.push(item)
				return item
			})
			
			this.list = this.Post_List
		},
	
		// 判断是否是该用户本人的帖子
		if_show_follow_btn(item){
			return true
			return this.$store.state.userinfo.user_id != item.user_id
		},
		
		get_if_routeName(){
			return this.routeName == 'home' || this.routeName.includes('post-details')
		},
		
		// 判断是否是首页，首页才显示列表的关注按钮
		get_routeName(){
			this.routeName = this.$route.name;
			console.log(this.routeName)
		},
		
		// 话题格式化
		set_subjects_text(subjects){
			if(subjects && subjects.length > 0){
				return "#" + subjects.join(" #");
			}else{
				return ""
			}
		},
		
		if_routeName_home(){
			return this.routeName == 'users' || this.routeName == 'user-profile'
		},
		
		//除了change_more按钮之外的点击事件都把current_operation收起
		get_addEventListener(){
			document.addEventListener('click', (e) => {
				const isMoreElement = e.target.closest('.change_more');
				if (!isMoreElement) {
				  this.$store.state.current_operation = '';
				}
			});
		},
		
		//关闭评论
		closureFun(type){
			this.contentBoxData = ''
			if(type == 'success'){
				this.$emit('sticky_operations', 'success')
			}
		},
		
		//评论
		preview(item){
			if(!this.$store.state.userinfo.login_token){
				this.LoginTips()
				return
			}
			this.contentBoxData = item
			this.contentBoxData.type = "post_a_comment"
			this.contentBoxData.title = "Comment"
		},
		
		LoginTips(){
			if(this.$IsConfirmExecute) { return }
			this.$IsConfirmExecute = true
			this.$MessageBox.confirm(
			   this.$t('ConfirmPrompt.experience_more'),
			   this.$t('ConfirmPrompt.Login_Tips'),
			   {
			      confirmButtonText: this.$t('buttonArr.Confirm'),
			      cancelButtonText: this.$t('buttonArr.Cancel'),
			      type: 'warning',
			   }
			).then((res) => {
				try {
				   // 用户点击了确认按钮
					console.log("用户点击了确认按钮")
					this.$router.replace({
						path: '/login',
						query: {
							redirect: this.$router.currentRoute.fullPath
						}
					})
				} catch (error) {
				   console.error('Error in then block:', error);
				}
				this.$IsConfirmExecute = false
			}).catch((err) => {
			   // 用户点击了取消按钮
				this.$IsConfirmExecute = false
				console.log("用户点击了取消按钮")
			});
			// 主动调用根组件的无障碍修复方法
  			this.$root.set_message_input()
		},
		
		//查看 粉丝或关注人信息
		check_information(item){
			console.log(item)
			// 除了首页的帖子,个人列表页面和其他用户页面的列表不能进入个人列表页面
			if(this.if_routeName_home()){ return }
			this.$router.push({
				name: this.$store.state.userinfo.user_id == item.user_id ? "user-profile" : "users",
				params: {
					user_id: item.user_id,
					nickname: item.nickname,
					// page: this.page_obj.page ? this.page_obj.page : '',
					// per_page: this.page_obj.per_page ? this.page_obj.per_page : ''
				}
			})
		},
		
		// 判断自己的帖子是否置顶,根据置顶显示不同按钮
		get_is_top(item, Operation){
			if(this.routeName == 'users' && Operation.type == 'dislikeuser'){
				return false
			}else{
				// is_top: 0|1, //是否置顶, 0否, 1是
				if(Operation.type != 'toppost' && Operation.type != 'canceltoppost'){
					return true
				}else{
					if(Operation.type == 'toppost' && item.is_top == 0){
						return true
					}else if(Operation.type == 'canceltoppost' && item.is_top == 1){
						return true
					}else{
						return false
					}
				}
			}
		},
		
		//点击更多操作
		change_more(item) {
		   // 如果当前操作项和点击项相同
		   if (this.$store.state.current_operation === item.post_id) {
		      // 切换显示状态
		      this.show_more_icon = !this.show_more_icon;
		      // 如果显示状态为 false，重置当前操作项
		      if (!this.show_more_icon) {
		         this.$store.state.current_operation = '';
		      }
		   } else {
		      // 如果当前操作项和点击项不同，设置当前操作项为点击项的 post_id，并显示更多操作
		      this.$store.state.current_operation = item.post_id;
		      this.show_more_icon = true;
		   }
		},
	
		//更多操作执行
		post_operation(item, Operation){
			console.log(item)
			console.log(Operation)
			if(Operation.type == "postnotinterest"){
				this.post_community_postnotinterest(item) //不感兴趣
			}else if(Operation.type == "dislikeuser"){
				this.post_community_dislikeuser(item) //不喜欢作者
			}else if(Operation.type == "postreport"){
				this.post_community_postreport(item) //举报帖子
			}else if(Operation.type == "delpost"){
				// this.post_community_delpost(item) //删除
				this.delpostItem = item
			}else if(Operation.type == "toppost"){
				this.post_community_toppost(item) //帖子置顶
			}else if(Operation.type == "canceltoppost"){
				this.post_community_canceltoppost(item) //取消置顶
			}
			
			if(Operation.type == "cancel_operation"){
				this.$store.state.current_operation = ''
			}else{
				let that = this
				setTimeout(()=>{
					that.$store.state.current_operation = ''
				}, 200)
			}
		},
		
		//确定删除帖子
		ConfirmFun(item) {
	      this.post_community_delpost(this.delpostItem) //删除
			this.delpostItem = ''
	   },
		
		//取消删除帖子
		CancelFun(){
			console.log(this.delpostItem)
			this.delpostItem = ''
		},
	
		//查看帖子详情详情
		view_details(item){
			console.log(item)
			return
			if(this.$route.name.includes('post-details')){ 
				this.$router.push({
					name: "post-details",
					params: {
						post_id: item.post_id,
						post_content: item.content,
						// page: this.page_obj.page ? this.page_obj.page : '',
						// per_page: this.page_obj.per_page ? this.page_obj.per_page : ''
					}
				})
			}
		},
	
		//更新当前状态
		change_state(item){
			console.log(item)
			console.log(this.page_name)
			if(this.page_name == 'home' || this.page_name == 'users' || this.page_name.includes('post-details')){
				this.post_community_userfollow(item)
			}else if(this.page_name == 'fans-list'){
				this.change_FanHomePage(item)
			}else if(this.page_name == 'recommand'){
				this.change_FollowList(item)
			}
		},
	
		//用户关注
		post_community_userfollow(item){
			if(!this.$store.state.userinfo.login_token){
				this.LoginTips()
				return
			}
			console.log(item)
			let obj = {
				user_id: item.user_id, 
				status: item.is_follow == 0 ? 1 : 2, //是否关注, is_follow:0否, 1是,  status: 1关注, 2取关
			}
			console.log(obj)
			post_community_userfollow(obj)
			.then((res) => {
				console.log(res)
				if(res.code == 0){
					this.$emit('sticky_operations', 'success')
				}else{
					this.exception_handling(res, "userfollow")
				}
			})
			.catch((err) => {
				console.log(err)
				this.exception_handling(err, "userfollow")
			})
		},
		
		//点赞(帖子)
		give(item, status){
			if(!this.$store.state.userinfo.login_token){
				this.LoginTips()
				return
			}
			let obj = {
				post_id: item.post_id, 
				status: item.is_thumb == 0 ? 1 : 2, //is_thumb: 是否点赞, 0否, 1是, 1是,  //status：1点赞, 2取消
			}
			console.log(obj)
			post_community_postthumb(obj)
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					this.$emit('sticky_operations', 'success')
				}else{
					this.exception_handling(res, "postthumb")
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err, "postthumb")
		   })
		},
		
		//不感兴趣
		post_community_postnotinterest(item){
			if(!this.$store.state.userinfo.login_token){
				this.LoginTips()
				return
			}
			post_community_postnotinterest({ post_id: item.post_id })
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					this.$emit('sticky_operations', 'success')
				}else{
					this.exception_handling(res, "postnotinterest")
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err, "postnotinterest")
		   })
		},
		
		//不喜欢该用户/作者
		post_community_dislikeuser(item){
			if(!this.$store.state.userinfo.login_token){
				this.LoginTips()
				return
			}
			post_community_dislikeuser({ user_id: item.user_id })
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					this.$message(this.$t('tipsArr.Feedback_success'), 'success')
					let that = this
					setTimeout(()=>{
						that.$emit('sticky_operations', 'success')
					}, 1000)
				}else{
					this.exception_handling(res, "dislikeuser")
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err, "dislikeuser")
		   })
		},
		
		//举报 (帖子)
		post_community_postreport(item){
			if(!this.$store.state.userinfo.login_token){
				this.LoginTips()
				return
			}
			let routeParams = {
			   name: "post-report",
			   params: {
			      post_id: item.post_id,
			      // page: this.page_obj.page ? this.page_obj.page : '',
			      // per_page: this.page_obj.per_page ? this.page_obj.per_page : ''
			   }
			};
			if (this.$route.name === 'home') {
				routeParams.params.previous = "posts-list";
			}else if (this.$route.name === 'users') {
				routeParams.name = "user-post-details"
				let path = this.$router.currentRoute.path
				let previous = path ? path.split("/")[1] : ''
				routeParams.params.previous = previous;
				
				let user = path ? path.split("/")[2] : ''
				if(user){
					routeParams.params.user = user;
				}
			}else if (this.$route.name.includes('post-details')) {
				routeParams.name = "user-post-report"
				let path = this.$router.currentRoute.path
				let previous = path ? path.split("/")[1] : ''
				routeParams.params.previous = previous;
				
				let user = path ? path.split("/")[2] : ''
				if(user){
					routeParams.params.user = user;
				}
			}else{
				let path = this.$router.currentRoute.path
				let previous = path ? path.split("/")[1] : ''
				routeParams.params.previous = previous;
			}
			this.$router.push(routeParams);
			// this.$router.push({
			// 	name: "post-report",
			// 	params: {
			// 		post_id: item.post_id,
			// 		// page: this.page_obj.page ? this.page_obj.page : '',
			// 		// per_page: this.page_obj.per_page ? this.page_obj.per_page : ''
			// 	}
			// })
			// let obj = {
			// 	post_id: item.post_id,
			// 	reasons: this.postreport.reasons,  //举报原因 array 必填
			// 	remark: this.postreport.remark, //说明 选填
			// }
			// post_community_postreport(obj)
		 //   .then((res) => {
			// 	console.log(res)
			// 	if(res.code == 0){
			// 		this.$emit('sticky_operations', 'success')
			// 	}else{
			// 		this.exception_handling(res, "postreport")
			// 	}
		 //   })
		 //   .catch((err) => {
			// 	console.log(err)
			// 	this.exception_handling(err, "postreport")
		 //   })
		},
		
		//帖子置顶
		post_community_toppost(item){
			if(!this.$store.state.userinfo.login_token){
				this.LoginTips()
				return
			}
			post_community_toppost({ post_id: item.post_id })
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					this.$emit('sticky_operations', 'success')
				}else{
					this.exception_handling(res, "toppost")
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err, "toppost")
		   })
		},
		
		//取消帖子置顶
		post_community_canceltoppost(item){
			if(!this.$store.state.userinfo.login_token){
				this.LoginTips()
				return
			}
			post_community_canceltoppost({ post_id: item.post_id })
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					this.$emit('sticky_operations', 'success')
				}else{
					this.exception_handling(res, "canceltoppost")
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err, "canceltoppost")
		   })
		},
		
		//删除帖子
		post_community_delpost(item){
			if(!this.$store.state.userinfo.login_token){
				this.LoginTips()
				return
			}
			console.log(item)
			post_community_delpost({ post_id: item.post_id })
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					this.$emit('sticky_operations', 'success')
				}else{
					this.exception_handling(res, "delpost")
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err, "delpost")
		   })
		},
			
		//异常处理
		exception_handling(err, typeNmae){
			let message = ''
			if(typeNmae == "dislikeuser"){
				if(err.code == 4000){
					message = this.$t('tipsArr.Disliked_user')
					this.$message(message, 'error')
				}
			}else{
				// message = this.$t('tipsArr.System_Error')
				this.$errorMessage(err)
			}
		},
		
		//更新当前状态
		change_FanHomePage(item){
			console.log('change_FanHomePage')	
			console.log(item)	
		},
		
		//更新当前状态
		change_FollowList(item){
			console.log('change_FollowList')	
			console.log(item)	
		}
	
  }
}
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
		font-family: Poppins, Poppins;
	}
	.Post-List-box {
		width: 100%;
	}
	.no_data_box{
		background-color: #ffffff;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #999;
		padding: 10px 10px;
		font-size: 14px;
		.no_data{
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
		}
		img{
			max-width: 100px;
			width: 100%;
		}
		.no_data_text{
			margin-top: 20px;
		}
	}
	
	@media screen and (min-width: 1024px) {
		.no_data_box{
			min-height: 300px;
		}
	}
	@media screen and (max-width: 1024px) {
		.no_data_box{
			/* 50+10+41+147+10 */
			min-height: calc(100vh - 288px);
		}
	}
	.list_box{
		/* margin-top: 26px; */
		.title{
			font-weight: 400;
			padding: 0px 10px;
			font-size: 15px;
			color: #000000;
			line-height: 18px;
			text-align: left;
			font-style: normal;
			text-transform: none;
		}
		.list_item{
			// margin-top: 10px;
			display: flex;
			padding: 10px 10px;
			// background-color: #ffffff;
			border-radius: 8px;
			display: flex;
			justify-content: space-between;
			&:first-child{
				margin-top: 0px;
			}
			.pictures_or_videos{
				overflow: hidden;
				border-radius: 8px;
			}
			.content_and_statistics{
				display: flex;
				flex-direction: column;
				justify-content: space-between;
			}
			.information_big_box{
				display: flex;
				justify-content: space-between;
				.information_box{
					display: flex;
					// width: calc(100% - 0px);
					width: calc(100% - 85px);
					.avatar_pointer{
						cursor: pointer;
					}
					.avatar_default{
						cursor: default;
					}
					.avatar{
						width: 40px;
						height: 40px;
						display: flex;
						justify-content: center;
						align-items: center;
						color: #505050;
						border-radius: 50%;
						overflow: hidden;
						img{
							width: 100%;
							height: 100%;
						}
						.el-icon-s-custom{
							height: 40px;
							display: flex;
							justify-content: center;
							align-items: center;
							width: 100%;
							height: 100%;
							display: flex;
							justify-content: center;
							align-items: center;
							border: 1px #f5f5f5 solid;
							border-radius: 50%;
							font-size: 20px;
							color: #999;
						}
					}
					.name_box{
						width: calc(100% - 52px);
						margin-left: 12px;
						height: 40px;
						display: flex;
						justify-content: center;
						flex-direction: column;
					}
					.name{
						font-weight: 400;
						font-size: 16px;
						color: #3C3C3C;
						line-height: 1.2;
						text-align: left;
						font-style: normal;
						text-transform: none;
						white-space: nowrap; 
						overflow: hidden; 
						text-overflow: ellipsis;
					}
					.release_time{
						margin-top: 5px;
						font-weight: 400;
						font-size: 10px;
						color: #666666;
						// color: #B3B3B3;
						line-height: 10px;
						text-align: left;
						font-style: normal;
						text-transform: none;
					}
				}
				.right_box{
					width: 100%;
					margin-left: 5px;
               max-width: 80px;
               display: flex;
               align-items: center;
               justify-content: flex-end;
					
				}
				.follow_status_box{
					display: flex;
					justify-content: center;
					align-items: center;
					.follow_status{
						width: 80px;
						height: 28px;
						font-weight: 400;
						font-size: 12px;
						color: #FFFFFF;
						line-height: 14px;
						text-align: center;
						font-style: normal;
						text-transform: none;
						padding: 5px 15px;
						border-radius: 15px 15px 15px 15px;
						cursor: pointer;
					}
					.Follow{
						color: #ffffff;
						background: #06f;
						border: 1px #06f solid;
						// background: #2094FA;
						// border: 1px #2094FA solid;
					}
					.Remove{
						color: #ffffff;
						background: #000000;
						border: 1px #000000 solid;
					}
					.Unfollow{
						color: #06f;
						background: #ffffff;
						border: 1px #06f solid;
						// color: #2094FA;
						// background: #ffffff;
						// border: 1px #2094FA solid;
					}
				}
				.sticky_box{
					cursor: default;
					font-size: 11px;
					padding: 5px 8px 7px 8px;
					background-color: rgba(0, 0, 0, 0.5);
					line-height: 1;
					color: #ffffff;
					border-radius: 4px;
					display: flex;
					align-items: center;
					justify-content: center;
				}
				.margin_right{
					margin-right: 10px;
				}
			}
		
			.content_icon_box{
				margin-top: 12px;
				display: flex;
				flex-direction: column;
				width: 100%;
				height: 100%;
				justify-content: space-between;
			}
			.content_subjects_box{
				width: 100%;
				.content_subjects{
					width: 100%;
				}
				.content_subjects_line_clamp{
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					overflow: hidden;
					text-overflow: ellipsis;
				}
				.subjects_text,
				.content_text{
					width: 100%;
					display: inline-flex; //与主题标签换行了
					font-family: Poppins, Poppins;
					font-weight: 400;
					font-size: 15px;
					line-height: 24px;
					text-align: left;
					font-style: normal;
					text-transform: none;
				}
				.subjects_text{
					margin-right: 10px;
					color: #2094FA;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					overflow: hidden;
					text-overflow: ellipsis;
					max-height: 24px;
					-webkit-line-clamp: 1;
				}
				.content_text{
					line-height: 1.5;
					color: #111111;
				}
				.PostDetails{
					max-height: 100%;
				}
				.content_text_line_clamp{
					display: -webkit-box;
					-webkit-box-orient: vertical;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}
			.post_list_item_bottom_box{
				width: 100%;
				display: flex;
				// border-top: 1px solid #CFDADE;
				.icon_box{
					margin-right: 24px;
					cursor: pointer;
					display: flex;
					align-items: center;
					&:last-child{
						margin-right: 0px;
					}
					.icon_box_img{
						width: 30px;
						height: 30px;
						img{
							width: 100%;
						}
						/* width: 14px; */
						/* font-size: 16px; */
						/* height: 12px; */
					}
					.icon_box_text{
						margin-left: 3px;
						font-weight: 400;
						font-size: 12px;
						color: #3C3C3C;
						line-height: 30px;
						text-align: left;
						font-style: normal;
						text-transform: none;
					}
				}
				.icon_box.browse{
					cursor: default;
				}
			}
			
		}
	}
	.post_list_item_bottom_box{
		display: flex;
	}
	/* 帖子详情页 */
	.PostDetails .list_item .post_list_item_bottom_box{
	   border-top: 0px solid #CFDADE;
	}
	.pointer{
		cursor: pointer;
		.name_box .name,
		.name_box .release_time,
		.icon_box.browse{
			cursor: pointer !important;
		}
	}
	.ordinary_list_box{
		.list_item{
			background-color: #ffffff;
		}
		.media-carousel {
		   width: 50% !important;
		   margin: 0 auto;
		}
	}
	.sticky_list_box{
		.list_item{
			background: linear-gradient(to bottom, #fddce3, #fffefe);
			// background: linear-gradient(to bottom, #fff9f9, #fffefe);
		}
	}
	
	.more_box{
		position: relative;
		.PostDetails{
			position: absolute;
			top: 0;
			right: 0;
			height: 35px;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 35px;
			margin-right: 10px;
			margin-top: 10px;
		}
		.more_relative{
			height: 100%;
			display: flex;
			align-items: center;
			cursor: pointer;
			position: relative;
		}
		.margin_left{
			margin-left: 12px;
		}
		.choice_box{
			width: 200px;
			display: flex;
			flex-direction: column;
			position: absolute;
			right: 0;
			top: 0;
			margin-top: 30px;
			background-color: #f5f5f5;
			box-shadow: 0.5px 0.5px 0  0.5 #000000;
			padding: 5px 0px;
			z-index: 99;
			border-radius: 8px;
		}
		.choice_item{
			padding: 5px 10px;
			font-size: 14px;
			list-style: 1;
			&:hover{
				background-color: aliceblue;
			}
		}
	}
	
	@media screen and (min-width: 1280px) {
		.pictures_or_videos{
		 	width: 50%;
		}
		.content_and_statistics{
		 	width: calc(50% - 10px);
		}
		.content_text_line_clamp{
			max-height: 72px;
			-webkit-line-clamp: 2;
		}
	}
	@media screen and (max-width: 1280px) and (min-width: 1100px) {
	   .pictures_or_videos{
	    	width: 45%;
	   }
	   .content_and_statistics{
	    	width: calc(55% - 10px);
	   }
		.content_text_line_clamp {
		   max-height: 72px;
			-webkit-line-clamp: 2;
		}
	}
	@media screen and (max-width: 1100px) and (min-width: 1024px) {
	   .pictures_or_videos{
	    	width: 45%;
	   }
	   .content_and_statistics{
	    	width: calc(55% - 10px);
	   }
		.content_text_line_clamp {
		   max-height: 72px;
			-webkit-line-clamp: 2;
		}
	}
	@media screen and (max-width: 1024px) and (min-width: 768px) {
	   .pictures_or_videos{
	    	width: 50%;
	   }
	   .content_and_statistics{
	    	width: calc(50% - 10px);
	   }
		.content_text_line_clamp {
		   max-height: 72px;
			-webkit-line-clamp: 2;
		}
	}
	@media screen and (max-width: 768px) and (min-width: 600px) {
	   .pictures_or_videos{
	    	width: 47%;
	   }
	   .content_and_statistics{
	    	width: calc(63% - 10px);
	   }
		.content_text_line_clamp {
		   max-height: 72px;
			-webkit-line-clamp: 2;
		}
	}
	@media screen and (max-width: 600px) and (min-width: 500px) {
	   .pictures_or_videos{
	    	width: 47%;
	   }
	   .content_and_statistics{
	    	width: calc(63% - 10px);
	   }
		.content_text_line_clamp {
		   max-height: 48px;
			-webkit-line-clamp: 2;
		}
	}
	
	@media screen and (min-width: 500px) {
		.content_and_statistics{
			margin-left: 10px;
		}
		.post_list_item_bottom_box{
			display: flex;
			justify-content: flex-end;
		}
	}
	@media screen and (max-width: 500px) {
		.list_item{
			flex-direction: column-reverse;
		}
		.pictures_or_videos{
			margin-top: 10px;
			padding-bottom: 15px;
		 	width: 100%;
			border-radius: 0px !important;
			border-bottom: 1px solid #CFDADE;
		}
		.content_and_statistics{
		 	width: 100%;
		}
		.content_text_line_clamp {
		   max-height: 48px;
		   -webkit-line-clamp: 2;
			position: relative;
		}
		.list_item{
			position: relative;
			padding-bottom: 50px !important;
		}
		.post_list_item_bottom_box{
			position: absolute;
			padding: 10px 10px;
			right: 0;
			bottom: 0;
			width: 100%;
		}
		.post_list_item_bottom_box{
			display: flex;
			justify-content: flex-start;
		}
	}
</style>
